export default class FsLightbox {
    private static initialized = false;

    static init(): void {
        if (this.initialized) {
            return;
        }

        // Wait for the library to be fully loaded
        setTimeout(() => {
            try {
                if (window.fsLightbox && window.fsLightbox.props) {
                    window.fsLightbox.props.showThumbsOnMount = true;
                }
            } catch (error) {
                console.warn('FsLightbox configuration failed:', error);
            }
        }, 100);

        this.initialized = true;
    }

    static reinitialize(): void {
        this.initialized = false;
        this.init();
    }
}

// Extend the global Window interface to include fsLightbox
declare global {
    interface Window {
        fsLightbox?: {
            props?: {
                showThumbsOnMount?: boolean;
            };
        };
    }
}
